export default __webpack_public_path__ + "static/media/continental.1ef635fd.png";